import MiniSelect from "./MiniSelect";
import { SHOT_TYPES, CAMERA_ANGLES, CAMERA_MOVEMENTS, LIGHTING_STYLES, LENS_OPTIONS } from "@/constants/shotSettings";
import { Camera, Video, Aperture, Lightbulb, Move } from "lucide-react";

const ROWS = [
  { key: "shotType", label: "Shot Type", options: SHOT_TYPES, icon: Camera },
  { key: "cameraAngle", label: "Camera Angle", options: CAMERA_ANGLES, icon: Video },
  { key: "cameraMovement", label: "Camera Movement", options: CAMERA_MOVEMENTS, icon: Move },
  { key: "lighting", label: "Lighting", options: LIGHTING_STYLES, icon: Lightbulb },
  { key: "lens", label: "Lens", options: LENS_OPTIONS, icon: Aperture },
];

export default function EquipmentTab({
  shotType, setShotType,
  cameraAngle, setCameraAngle,
  cameraMovement, setCameraMovement,
  lighting, setLighting,
  lens, setLens,
}) {
  const values = { shotType, cameraAngle, cameraMovement, lighting, lens };
  const setters = { shotType: setShotType, cameraAngle: setCameraAngle, cameraMovement: setCameraMovement, lighting: setLighting, lens: setLens };

  return (
    <div className="space-y-3">
      {ROWS.map((row) => (
        <div key={row.key}>
          <label className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--text-muted)] mb-1.5 block">
            {row.label}
          </label>
          <MiniSelect
            options={row.options}
            value={values[row.key]}
            onChange={setters[row.key]}
            label={row.label}
            icon={row.icon}
          />
        </div>
      ))}
    </div>
  );
}
